(function (window, document) {
  "use strict";

  var PRODUCT_ID = "3955562414198";
  var ROOT_SELECTOR =
    '[data-pilot-gallery-product-id="' + PRODUCT_ID + '"]';
  var DIAGNOSTIC_LIMIT = 5;
  var diagnosticCount = 0;
  var inFlightRequests = [];
  var readySources = [];

  function forEach(nodes, callback) {
    Array.prototype.forEach.call(nodes, callback);
  }

  function reportDiagnostic(code) {
    if (diagnosticCount >= DIAGNOSTIC_LIMIT) {
      return;
    }
    diagnosticCount += 1;

    if (
      window.console &&
      typeof window.console.warn === "function"
    ) {
      window.console.warn.call(
        window.console,
        "[pilot-gallery] " + code
      );
    }
  }

  function setState(image, state, loaded) {
    image.setAttribute("data-pilot-state", state);
    image.setAttribute("data-pilot-loaded", loaded ? "true" : "false");
  }

  function settleDecode(image, ready, failed) {
    var decodeResult;

    if (typeof image.decode !== "function") {
      ready();
      return;
    }

    try {
      decodeResult = image.decode();
    } catch (error) {
      failed();
      return;
    }

    if (decodeResult && typeof decodeResult.then === "function") {
      decodeResult.then(ready, failed);
    } else {
      failed();
    }
  }

  function sourceKey(src, srcset, sizes) {
    return [src, srcset || "", sizes || ""].join("\n");
  }

  function findRequest(key) {
    var match = null;

    forEach(inFlightRequests, function (request) {
      if (request.key === key) {
        match = request;
      }
    });
    return match;
  }

  function removeRequest(request) {
    var index = inFlightRequests.indexOf(request);

    if (index !== -1) {
      inFlightRequests.splice(index, 1);
    }
  }

  function isReadySource(key) {
    return readySources.indexOf(key) !== -1;
  }

  function markSourceReady(key) {
    if (!isReadySource(key)) {
      readySources.push(key);
    }
  }

  function swapReadyImage(image, src, srcset) {
    if (srcset) {
      image.setAttribute("srcset", srcset);
    }
    image.setAttribute("src", src);
    setState(image, "ready", true);
  }

  function finishRequestReady(request) {
    if (request.done) {
      return;
    }
    request.done = true;
    removeRequest(request);
    markSourceReady(request.key);

    forEach(request.waiters, function (image) {
      swapReadyImage(image, request.src, request.srcset);
    });
  }

  function finishRequestError(request, diagnosticCode) {
    if (request.done) {
      return;
    }
    request.done = true;
    removeRequest(request);

    forEach(request.waiters, function (image) {
      setState(image, "error", false);
    });
    reportDiagnostic(diagnosticCode);
  }

  function startRequest(key, src, srcset, sizes) {
    var preloader = new window.Image();
    var request = {
      done: false,
      key: key,
      preloader: preloader,
      src: src,
      srcset: srcset,
      waiters: [],
    };

    inFlightRequests.push(request);
    preloader.decoding = "async";
    preloader.onload = function () {
      settleDecode(
        preloader,
        function () {
          finishRequestReady(request);
        },
        function () {
          finishRequestError(request, "decode-failed");
        }
      );
    };
    preloader.onerror = function () {
      finishRequestError(request, "request-failed");
    };

    if (sizes) {
      preloader.sizes = sizes;
    }
    if (srcset) {
      preloader.srcset = srcset;
    }
    preloader.src = src;
    return request;
  }

  function activateImage(image) {
    var key;
    var request;
    var sizes;
    var src;
    var srcset;
    var state;

    if (!image) {
      return;
    }

    state = image.getAttribute("data-pilot-state");
    if (
      state === "requested" ||
      state === "ready" ||
      image.getAttribute("data-pilot-loaded") === "true"
    ) {
      return;
    }

    src = image.getAttribute("data-pilot-src");
    srcset = image.getAttribute("data-pilot-srcset");
    sizes = image.getAttribute("sizes");

    if (!src) {
      setState(image, "error", false);
      reportDiagnostic("missing-source");
      return;
    }

    image.setAttribute("loading", "eager");
    setState(image, "requested", false);
    key = sourceKey(src, srcset, sizes);

    if (isReadySource(key)) {
      swapReadyImage(image, src, srcset);
      return;
    }

    request = findRequest(key);
    if (!request) {
      request = startRequest(key, src, srcset, sizes);
    }
    request.waiters.push(image);
  }

  function activateByIndex(root, index) {
    var selector =
      '[data-pilot-gallery-image][data-pilot-gallery-index="' +
      String(index) +
      '"]';
    forEach(root.querySelectorAll(selector), activateImage);
  }

  function activateByImageId(root, imageId) {
    var wrappers = root.querySelectorAll(
      ".product-single__photo[data-image-id]"
    );

    forEach(wrappers, function (wrapper) {
      if (
        String(wrapper.getAttribute("data-image-id")) === String(imageId)
      ) {
        forEach(
          wrapper.querySelectorAll("[data-pilot-gallery-image]"),
          activateImage
        );
      }
    });
  }

  function activateCurrentSlide(root) {
    var slide;
    var slider = root.querySelector(".slider-for");

    if (!slider || typeof slider.querySelector !== "function") {
      return;
    }

    slide =
      slider.querySelector(
        ".slick-slide.slick-current:not(.slick-cloned)"
      ) ||
      slider.querySelector(".slick-slide.slick-current") ||
      slider.querySelector(
        '.slick-slide[aria-hidden="false"]:not(.slick-cloned)'
      ) ||
      slider.querySelector('.slick-slide[aria-hidden="false"]');

    if (!slide) {
      return;
    }

    forEach(
      slide.querySelectorAll("[data-pilot-gallery-image]"),
      activateImage
    );
  }

  function dotIndex(dot) {
    if (!dot || !dot.parentNode || !dot.parentNode.children) {
      return -1;
    }
    return Array.prototype.indexOf.call(dot.parentNode.children, dot);
  }

  function scheduleSecondImage(root) {
    var loadSecond = function () {
      activateByIndex(root, 1);
    };

    if ("requestIdleCallback" in window) {
      window.requestIdleCallback(loadSecond, { timeout: 1600 });
    } else {
      window.setTimeout(loadSecond, 350);
    }
  }

  function trackFirstImage(root) {
    var first = root.querySelector(
      '[data-pilot-gallery-image][data-pilot-gallery-index="0"]'
    );
    var settled = false;

    if (!first) {
      return;
    }

    function ready() {
      if (settled) {
        return;
      }
      settled = true;
      setState(first, "ready", true);
      scheduleSecondImage(root);
    }

    function loaded() {
      settleDecode(first, ready, function () {
        fail("initial-decode-failed");
      });
    }

    function fail(diagnosticCode) {
      if (settled) {
        return;
      }
      settled = true;
      setState(first, "error", false);
      reportDiagnostic(diagnosticCode);
    }

    function failed() {
      fail("initial-request-failed");
    }

    if (
      first.getAttribute("data-pilot-state") === "ready" &&
      first.getAttribute("data-pilot-loaded") === "true"
    ) {
      scheduleSecondImage(root);
    } else if (first.complete) {
      if (first.naturalWidth > 0) {
        loaded();
      } else {
        failed();
      }
    } else {
      first.addEventListener("load", loaded, { once: true });
      first.addEventListener("error", failed, { once: true });
    }
  }

  function bindJQuery(root) {
    var $root;
    var $slider;

    if (
      !root ||
      root.getAttribute("data-pilot-gallery-jquery-bound") === "true" ||
      typeof window.jQuery !== "function"
    ) {
      return;
    }

    $root = window.jQuery(root);
    if (
      !$root ||
      typeof $root.on !== "function" ||
      typeof $root.find !== "function"
    ) {
      return;
    }

    $slider = $root.find(".slider-for");
    if (!$slider || typeof $slider.on !== "function") {
      return;
    }

    $root.on(
      "variantImageChange.pilotGallery",
      function (event) {
        var variant = event.variant;
        var featuredImage = variant && variant.featured_image;
        if (featuredImage && featuredImage.id) {
          activateByImageId(root, featuredImage.id);
        }
      }
    );

    $slider.on(
      "beforeChange.pilotGallery",
      function (event, slick, currentSlide, nextSlide) {
        activateByIndex(root, nextSlide);
      }
    );

    $slider.on(
      "init.pilotGallery reInit.pilotGallery",
      function (event, slick) {
        var currentSlide = slick ? slick.currentSlide : 0;
        activateByIndex(root, currentSlide || 0);
      }
    );

    root.setAttribute("data-pilot-gallery-jquery-bound", "true");
  }

  function bindCore(root) {
    var observer;
    var slider;

    if (
      !root ||
      root.getAttribute("data-pilot-gallery-core-bound") === "true"
    ) {
      return;
    }
    root.setAttribute("data-pilot-gallery-core-bound", "true");

    root.addEventListener(
      "click",
      function (event) {
        var index;
        var dot;
        var thumbnail = event.target.closest(
          ".product-single__thumbnail[data-thumbnail-id]"
        );

        if (thumbnail && root.contains(thumbnail)) {
          activateByImageId(
            root,
            thumbnail.getAttribute("data-thumbnail-id")
          );
          return;
        }

        dot = event.target.closest(".slick-dots li");
        if (!dot || !root.contains(dot)) {
          return;
        }

        index = dotIndex(dot);
        if (index >= 0) {
          activateByIndex(root, index);
        }
      },
      true
    );

    slider = root.querySelector(".slider-for");
    if (slider) {
      if (typeof window.MutationObserver === "function") {
        observer = new window.MutationObserver(function () {
          bindJQuery(root);
          activateCurrentSlide(root);
        });
        observer.observe(slider, {
          attributes: true,
          attributeFilter: ["class", "aria-hidden"],
          childList: true,
          subtree: true,
        });
      } else {
        reportDiagnostic("mutation-observer-unavailable");
      }
    }

    trackFirstImage(root);
    activateCurrentSlide(root);
  }

  function bindPilot(root) {
    if (!root) {
      return;
    }
    bindCore(root);
    bindJQuery(root);
  }

  function boot(scope) {
    if (scope.matches && scope.matches(ROOT_SELECTOR)) {
      bindPilot(scope);
    }
    if (scope.querySelectorAll) {
      forEach(scope.querySelectorAll(ROOT_SELECTOR), bindPilot);
    }
  }

  if (document.readyState === "loading") {
    document.addEventListener(
      "DOMContentLoaded",
      function () {
        boot(document);
      },
      { once: true }
    );
  } else {
    boot(document);
  }

  document.addEventListener("shopify:section:load", function (event) {
    boot(event.target);
  });
})(window, document);
